<template>
    <div @click="clickNode">
        <toast></toast>
        <div class="patch-home">
            <div class="head-list col-md-12">
                <!--        头部数据-->
                <head-data class="head-data" :value="dataListValue"></head-data>
            </div>
            <div class="row patch-home-content col-md-12 pr-md-0">
                <!--左边列-->
                <div class="left col-md-4 col-sm-12 col-lg-3">
                    <div class="graph-wrap d-md-none">
                        <div class="triangle" style="font-size: 8px"></div>
                        <classify-tabs :value="grphClassifyValue"
                                       @changeTab="changeRouter"></classify-tabs>
                        <el-select v-model="extraData.name"
                                   size="mini"
                                   @change="()=>requestGraph()"
                                   placeholder="select"
                                   class="choose">
                            <el-option
                                    v-for="item in cities"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.value">
                                <!--                                <span style="float: left; color: #ccc4cf; font-size: 12px">-->
                                <!--                                    {{ item.label }}-->
                                <!--                                </span>-->
                                <span style="font-size: 12px">
                                    {{ item.value }}
                                </span>
                            </el-option>
                        </el-select>
                        <normal-graph :value="graphValue" @changeGraph="gotoCountry" class="normal-graph"
                                      ref="graph" v-show="!isMap"
                                      :has-legend="true"
                                      v-if="!isBigGraph"
                                      :is-layout="true"
                                      @doubleClick="addNode"
                        ></normal-graph>
                    </div>
                    <!--          左侧上方 Provincial GDP指标图-->
                    <div class="country-state-chart">
                        <router-link :to="{name: 'Company'}" class="more-btn middle-hidden">More>></router-link>
                        <classify-tabs :value="countryStateValue" class="classify-tabs"></classify-tabs>
                        <el-select v-model="rankingValue.active" size="mini" class="ranking-select"
                                   @change="(event)=>selectChaneRanking(event,'BarTickAlign')">
                            <el-option v-for="item in rankingValueSelectArr" :key="item.name" :value="item.name"
                                       :label="item.name">
                                <span v-if="item.name !== 'More'">{{item.name}}</span>
                                <router-link v-else :to="{name: 'Company'}" @click.stop>
                                    <!-- <i class="el-icon-s-data"></i> -->
                                    <span>{{item.name}}</span>
                                </router-link>
                            </el-option>
                        </el-select>
                        <div class="rank-chart">
                            <ranking class="ranking" :value="rankingValue" @click="requestBarTickAlign"></ranking>
                            <bar-tick-align class="bar-tick-align"
                                            gridTop='20' :value="barTickAlignValue"></bar-tick-align>
                        </div>
                    </div>
                    <!--          左侧下方企业指标图-->
                    <div class="country-state-chart firm-chart">
                        <router-link :to="{name: 'BigFrame'}" class="more-btn">More>></router-link>
                        <classify-tabs :value="firmStateValue" class="classify-tabs"></classify-tabs>
                        <div class="rank-chart">
                            <!--                                 alt="">-->
                            <!--                            <ranking class="ranking-base" :value="rankingFirmValue" @click="requestAreaBasec"></ranking>-->
                            <!--                            <area-basic class="area-base" :value="areaBasicValue"-->
                            <!--                                        gridTop="20" :axisLabel="areaBasicValue.axisLabel"></area-basic>-->
                            <p class="ps">JD overseas word cloud</p>
                            <e-word-cloud
                                    class="overseas-enthusiasm"
                                    :sizeRange="[10, 30]"
                                    :is-nodata="isNodata"
                                    :no-save-as-image="true"
                                    :wordData="wordData"></e-word-cloud>
                        </div>
                    </div>
                    <!--          Videos-->
                    <service-entrance @gotoService="gotoService" :value="seriviceValue"
                                      class="service-entrance"></service-entrance>
                </div>
                <div class="middle col-md-8 col-sm-12 col-lg-6 pl-md-0">
                    <banner :value="bannerValue.list" :height="bannerValue.height" :trigger="bannerValue.trigger"
                            class="cursor banner-wrap"
                            @change="bannerInto"></banner>
                    <div class="filter-content" id="filter-content">
                        <div class="filter-head-tab">
                            <classify-tabs :value="classifyTabsValue" class="classify-tabs-wrap"
                                           @changeTab="changeSelectType">
                            </classify-tabs>
                            <el-button size="mini" slot="label" @click="selectTab"
                                       class="select-button" style="border: none;">
                                select
                            </el-button>

                            <!--                            <div @click="selectTab" class="triangle-mid">-->
                            <!--                            </div>-->
                        </div>
                        <select-popcomfirm :value="selectValue" class="select-dialog-wrap"
                                           v-show="selectVisible"
                                           ref="selectPopcomfirm"
                                           @selectItem="selectItem"></select-popcomfirm>
                        <selection-list :value="selectListValue"
                                        :key="selectType"
                                        class="select-list-wrap"
                                        ref="selectionList"
                                        @jumpList="requestSelectList"
                                        @change="gotoSearchDetail"></selection-list>
                    </div>
                </div>
                <!--        // 右侧专题切换-->
                <div class="right col-sm-12 col-lg-3 pl-md-0 pr-md-0 mt-md-0 mt-sm-2">
                    <!--上-->
                    <div class="graph-wrap">
                        <div class="triangle" style="font-size: 8px"></div>
                        <classify-tabs :value="grphClassifyValue"></classify-tabs>
                        <!--                        <classify-tabs :value="grphClassifyValue" @changeTab="changeRouter"></classify-tabs>-->
                        <el-select v-model="extraData.name"
                                   size="mini"
                                   @change="()=>requestGraph()"
                                   placeholder="select"
                                   class="choose">
                            <el-option
                                    v-for="item in cities"
                                    :key="item.value"
                                    :label="item.value"
                                    :value="item.value">
                                <!--                                <span style="float: left; color: #ccc4cf; font-size: 12px">-->
                                <!--                                    {{ item.label }}-->
                                <!--                                </span>-->
                                <span style="font-size: 12px">
                                    {{ item.value }}
                                </span>
                            </el-option>
                        </el-select>
                        <normal-graph :value="graphValue" @changeGraph="gotoCountry" class="normal-graph"
                                      ref="graph" v-show="!isMap"
                                      v-if="isBigGraph"
                                      :isRollZommNum="true"
                                      :isCenter="true"
                                      :is-layout="true"
                                      @doubleClick="addNode"
                                      :has-legend="true"
                        ></normal-graph>
                    </div>
                    <!--下-->
                    <div class="people-column">
                        <div class="char-title-conent">
                            <classify-tabs :value="peopleStateValue" @changeTab="changePeopleClassify"
                            ></classify-tabs>
                            <router-link :to="{
                name: 'consult_particulars_organization',
                params: {type: '1',id: '10'}}" class="database">More>>
                            </router-link>
                        </div>
                        <!--            <div class="people-column-content" v-if="typeid === 4">-->
                        <!--              <iframe-->
                        <!--                :src="botUrl"-->
                        <!--                style="height: 100%; width: 100%;"></iframe>-->
                        <!--            </div>-->
                        <character-column :value="characterColumnValue"
                                          class="people-column-content"
                                          @change="changeColumn"
                                          @jumpList="requestCharacterColumn">
                        </character-column>
                        <!--                             alt="">-->
                    </div>
                </div>
            </div>
        </div>
        <!--        <el-dialog-->
        <!--                :visible.sync="botShow"-->
        <!--                class="bot-dialog"-->
        <!--                width="900px"-->
        <!--                v-drag="true"-->
        <!--                :close-on-click-modal="false"-->
        <!--        >-->
        <!--            <bot-iframe :bot-url="botUrl" ref="botIframe" :isDrag="true"></bot-iframe>-->
        <!--        </el-dialog>-->
        <!--        <bot-entrance class="bot-wrap hidden-sm" @openBot="openBot()"-->
        <!--                      v-drag="true"></bot-entrance>-->
        <consult-dialog v-if="consultVisible" :value="consultValue"
                        @saveConsult="saveConsult"></consult-dialog>
    </div>
</template>

<script>
import ranking from './components/ranking'
import areaBasic from './components/areaBasic'
import barTickAlign from './components/barTickAlign'
import pdTabs from './components/pdTabs'
import ClassifyTabs from '@/views/search/components/classifyTabs'
import banner from './components/banner'
import NormalGraph from '@/views/search/components/normalGraph'
import MixinUpdateData from './mixins/updateData'
import CharacterColumn from './components/characterColumn'
import SelectionList from './components/selectionList'
import SelectPopcomfirm from './components/selectPopcomfirm'
import ServiceEntrance from './components/serviceEntrance'
import HeadData from './components/headData'
import BotEntrance from './components/botEntrance'
import searchMap from '@/views/search/utils/searchMap'
import * as _ from 'lodash'
import ConsultDialog from './components/consultDialog'
import Toast from '../silkRoadBase/components/toast/Toast'
import MixinsHandleGraph from './mixins/handleGraph'
import BotIframe from './components/botIframe'
import MixinDataTime from './mixins/dateTime'
import OverseasEnthusiasm from '@/views/censThreePage/logoDetail/components/OverseasEnthusiasm'
import EWordCloud from '@/views/censThreePage/logoDetail/components/homePage/components/WordCloud.vue'
import $ from 'jquery'
import {
  botUrl,
  searchStatistics,
  countryStatistics,
  spaceList
} from '@/common/js/http/pdBase'
import {baseUrl} from 'common/js/http/pdBase'
import {findToken, wordPicture} from 'common/js/http/version3Api'

export default {
  name: 'theHome',
  components: {
    EWordCloud,
    OverseasEnthusiasm,
    BotIframe,
    Toast,
    ConsultDialog,
    BotEntrance,
    HeadData,
    ServiceEntrance,
    SelectPopcomfirm,
    SelectionList,
    CharacterColumn,
    NormalGraph,
    ClassifyTabs,
    ranking,
    areaBasic,
    barTickAlign,
    pdTabs,
    banner
  },
  mixins: [MixinUpdateData, MixinsHandleGraph, MixinDataTime],
  data () {
    return {
      wordData: {},
      isNodata: false,
      isChaneBannerToken: false,
      searchToken: '',
      cities: [],
      extraData: {
        name: 'Beijing'
      },
      echarts: [
        'Graph',
        'AreaBasec',
        'BarTickAlign',
        'CharacterColumn',
        'SelectList',
        'HeadData',
        'Banner'
        // 'ServiceLink'
      ],
      selectVisible: false,
      isMap: false, // 显示专题还是地图
      id: '',
      apiSearchNode: '/ensearch/graphExplore2',
      botShow: false,
      selectType: 'all',
      filters: [],
      consultValue: {
        refsname: '',
        refsid: '',
        advisorytitle: '',
        advisorycontent: '',
        advisorycompany: '',
        advisoryname: '',
        advisoryphone: '',
        advisoryemail: '',
        advisoryaddress: '',
        advisorycapat: ''
      },
      botUrl: botUrl + '15909832704286430',
      typeid: 1,
      consultVisible: true,
      askObj: {
        refsid: '',
        refsname: ''
      },
      // 右下记者人物的分类筛选
      peopleStateValue: [{
        label: 'Consulting Service',
        value: 1
      }],
      graphRouterName: 'chinaTopics',
      dataListValue: {
        // all:{
        //   name: '资源总量',
        //   number: '+50',
        //   total: '9,800'
        // },
        dataList: [
          {
            name: 'Total number of companies',
            number: '+50',
            total: '0'
          },
          {
            name: 'Total M&A transactions',
            number: '+50',
            total: '0'
          },
          {
            name: 'Total number of economic indicators',
            number: '+50',
            total: '0'
          },
          {
            name: 'The number of Chinese brands tracked',
            number: '+50',
            total: '0'
          },
          {
            name: 'Knowledge graph entities',
            number: '+50',
            total: '0'
          },
          {
            name: 'Knowledge graph relations',
            number: '+50',
            total: '0'
          }
        ]
      },
      seriviceValue: [
        // {
        //   imgUrl: 'https://img.imsilkroad.com/a/10005/202103/baacbaec02a28e786b2c7bb8eb73b5b5.png',
        //   title: `Welcome to Xiandu in east China's Zhejiang`,
        //   time: '2021-03-29',
        //   url: 'https://en.imsilkroad.com/db/#/video/1/article/320577'
        // },
        // {
        //   imgUrl: 'https://img.imsilkroad.com/a/10005/202103/37c1a591d2b16d4005720139a3e2e8c1.jpg',
        //   title: `GLOBALink | 1st China-Europe freight train linking Chengdu and St. Petersburg arrives at destination`,
        //   time: '2021-03-17',
        //   url: 'https://en.imsilkroad.com/db/#/video/1/article/320343'
        // },
        // {
        //   imgUrl: 'https://img.imsilkroad.com/a/10005/202103/848134043dc2cdd10c34e4d82b40a922.png',
        //   title: `The Greater Bay Area embraces new round of foreign investment amid new five-year plan`,
        //   time: '2021-03-16',
        //   url: 'https://en.imsilkroad.com/db/#/video/1/article/320318'
        // },
        // {
        //   imgUrl: 'https://img.imsilkroad.com/a/10005/202103/cb159382794d572d67a2b4c0a3f9b7d7.png',
        //   title: `GLOBALink | China's poverty fight shows strong leadership and political will: UN official`,
        //   time: '2021-03-03',
        //   url: 'https://en.imsilkroad.com/db/#/video/1/article/320028'
        // },
        // {
        //   imgUrl: 'https://img.imsilkroad.com/a/10005/202009/beecc59817339183ad75016781b862ba.png',
        //   title: 'Get a preview of the Winter Olympics at CIFTIS',
        //   time: '2020-09-10',
        //   url: 'https://en.imsilkroad.com/db/#/video/1/article/316092'
        // },
        // {
        //   imgUrl: 'https://img.imsilkroad.com/a/10005/202009/59ffd153f95c9b965eae7beee3f75de7.jpg',
        //   title: '2020 China International Fair for Trade in Services',
        //   time: '2020-09-10',
        //   url: 'https://en.imsilkroad.com/db/#/video/1/article/316091'
        // }
      ],
      selectListValue: {
        page: 1,
        size: 10,
        total: 10,
        spaceLoadShow: false,
        spaceEndShow: false,
        load: false,
        content: []
      },
      selectValue: [],
      firmStateValue: [{
        label: 'China Brands',
        value: '0'
      }],
      // 国家指标
      countryStateValue: [
        {
          label: 'Provincial GDP',
          value: '0'
        }
        // {
        //   label: '国家经济指标',
        //   value: '1'
        // }
      ],
      grphClassifyValue: [
        {
          label: 'Special topics for provinces',
          value: 'nationalCityTopics',
          extraData: {
            timeFilter: ''
          },
          layout: 'static',
          // layout: 'force',
          apiSearchNode: '/ensearch/graphExplore',
          apiSearchId: '/country/getEntityId'
        }
        // {
        //   label: '智讯热点',
        //   value: 'hotspot'
        // },
        // {
        //   label: '专利专题',
        //   value: 'patentTopics',
        //   layout: 'static',
        //   extraData: {
        //     timefilter: 1,
        //     patentCountry: 1,
        //     keywordIdList: []
        //   },
        //   apiSearchNode: '/patent/graphExplore',
        //   apiSearchId: '/patent/getEntityId'
        // },
        // {
        //   label: '项目案例专题',
        //   value: 'projectCaseTopics',
        //   layout: 'radial',
        //   extraData: null,
        //   apiSearchNode: '/project/graphExplore',
        //   apiSearchId: '/project/getEntityId'
        // },
        // {
        //   label: '丝路稿件专题',
        //   value: 'excavateTopics',
        //   apiSearchNode: '/product/graphExplore',
        //   layout: 'radial',
        //   extraData: {
        //     reportType: '',
        //     timeFilter: ''
        //   },
        //   apiSearchId: '/product/getEntityId'
        // },
        // {
        //   label: '企业专题', // 还没有接口
        //   value: 'enterpriseExpert',
        //   apiSearchNode: '/product/graphExplore',
        //   layout: 'radial',
        //   extraData: {
        //     reportType: '',
        //     timeFilter: ''
        //   },
        //   apiSearchId: '/product/getEntityId'
        // }
      ],
      characterColumnValue: {
        content: [],
        spaceEndShow: false,
        spaceLoadShow: false,
        page: 1
      },
      classifyTabsValue: [
        {
          label: 'Information',
          value: 'all'
        }
      ],
      graphValue: {
        graph: null,
        haveNoPage: true,
        layout: 'static'
        // layout: 'force'
      },
      rankingFirmValue: {
        arr: [],
        active: ''
      },
      rankingValue: {
        arr: [],
        active: ''
      },
      areaBasicValue: {
        axisLabel: {
          // interval: 0,
          rotate: 45
        },
        // title: 'China Brands总量月度统计',
        xAxis: [],
        series: [],
        name: ''
      },
      barTickAlignValue: {
        axisLabel: {
          // interval: 0,
          rotate: 45
        },
        // title: 'GDP年度统计',
        xAxis: [],
        series: [],
        name: ''
      },
      pdTabsArr: [
        {name: '国家1', key: '国家1'},
        {name: '国家2', key: '国家2'},
        {name: '国家3', key: '国家3'},
        {name: '国家4', key: '国家4'}
      ],
      bannerValue: {
        list: [],
        height: '100%',
        trigger: 'click'
      },
      isBigGraph: true,
      column: { // 二级栏目存放列表
        'all': []
        // 'inquiry': ['经济', '美洲智库', '政治', '出口风险预警', '亚太智库', '欧洲智库', '涉华', '社会', '军事', '能源', '科技', '环保', '基建', '质检', '智库活动', '国外市场准入', '焦点事件', '非洲智库', '质检信息平台'],
        // 'case': ['发展战略', '吉林要闻', '品牌建设', '技术创新', '风险防范', '跨国并购', '资金渠道', '案例', '吉林']
      },
      columnApi: {
        all: '/search/getSubCat/en'
      }
    }
  },
  computed: {
    rankingValueSelectArr () {
      return [...this.rankingValue.arr, {name: 'More'}]
    }
  },
  mounted () {
    this.getColumn()
    this.$nextTick(() => {
      this.updateEcharts()
    })
    this.getProvinceList()
    const _that = this
    _that.watchChangeSize()
    window.onresize = () => {
      _that.watchChangeSize()
    }
    this.getChinaBannerToken()
      .then(() => {
        this.getWord()
      })
    this.getVideoList()
  },
  methods: {
    getColumn () {
      for (let key in this.column) {
        this.getAxiosColumn(key)
      }
    },
    getAxiosColumn (type) {
      this.$pdAxios({
        url: this.columnApi[type],
        method: 'get',
        // baseURL: 'http://xinhuasilu-dev.kg.plantdata.cn/kgapi'
        baseURL: baseUrl
      })
        .then((data) => {
          if (data.data.errCode === 200) {
            const _data = data.data.data
            const arr = []
            if (_data) {
              for (let key in _data) {
                const o = {
                  value: key,
                  key: key,
                  children: []
                }
                o.children = _data[key].map((item) => {
                  return {
                    value: item,
                    key: item
                  }
                })
                !o.children.length && delete o.children
                arr.push(o)
              }
              this.column[type] = arr
              if (this.selectValue.length) {
                const columnMessage = this.createCatName(this.selectType)
                columnMessage.isExist && this.selectValue.unshift(columnMessage.column)
                for (let item of selectValue) {
                  if (item && item.k.name) {
                    item.k._name = searchMap.chinaToEnglish[item.k.name] || ''
                  }
                }
              }
            }
          }
        })
    },
    getChinaBannerToken () {
      return findToken().then(res => {
        if (res.code === 200) {
          let userId = res.result.userId
          localStorage.setItem('brand-token', res.result.brandToken)
          return Promise.resolve
        }
      })
    },
    getWord () {
      const time = new Date().getTime() - 24 * 60 * 60 * 1000
      const yesday = new Date(time)
      const month = yesday.getMonth()
      const day = yesday.getDate()
      const resDate =
        yesday.getFullYear() +
        '-' +
        (yesday.getMonth() > 9
          ? yesday.getMonth() + 1
          : '0' + (yesday.getMonth() + 1)) +
        '-' +
        (yesday.getDate() > 9 ? yesday.getDate() : '0' + yesday.getDate())
      // debugger
      let startDate = this.$moment(new Date())
        .subtract(90, 'days')
        .format('YYYY-MM-DD') || 'Invalid date'
      let endDate = this.$moment(new Date()).format('YYYY-MM-DD') || 'Invalid date'
      let data = {
        companyId: 3,
        regionalNames: '',
        startTime: '2020-01-01', // startDate,
        endTime: '2020-12-31', // endDate
      }
      wordPicture(data).then(res => {
        this.wordData = res.result.series[0].data
        if (this.wordData.length === 0) {
          this.isNodata = true
        } else {
          this.isNodata = false
        }
      })
    },
    getProvinceList () {
      this.$pdAxios({
        method: 'post',
        url: '/ensearch/province',
        baseURL: baseUrl
      })
        .then((data) => {
          if (data.data.errCode === 200) {
            let _data = data.data.data
            _data = _.uniq(_data)
            this.cities = _.map(_data, (item) => {
              return {value: item}
            })
          }
        })
    },
    watchChangeSize () {
      // 可视区的宽/高(DOM)
      // offsetHeight（带边框）和clientHeight（不带边框）区别参考上一篇文章
      var offsetWid = document.documentElement.clientWidth
      this.isBigGraph = offsetWid > 766
    },
    requestHeadData () {
      searchStatistics()
        .then((data) => {
          if (data.errCode === 200) {
            const _data = data.data.data
            const map = {
              'Knowledge graph entities': 'entityCount',
              'Total number of economic indicators': 'totalIndicatorCount',
              'The number of Chinese brands tracked': 'patentCount',
              'Knowledge graph relations': 'relationCount',
              'Total number of companies': 'totalNumberOfCompaines',
              'Total M&A transactions': 'totalM&ATransactions'
            }
            _.forEach(this.dataListValue.dataList, (item) => {
              const key = map[item.name]
              if (_data[key]) {
                item.total = _data[key]
              }
            })
          } else {
            return Promise.reject(new Error(''))
          }
        })
        .catch((error) => {
          // this.$message.error('统计数据总量有问题')
        })
    },
    requestAreaBasec (item = null) {
      // if (item) {
      //   this.areaBasicValue.xAxis = []
      //   this.areaBasicValue.series = []
      //   _.forEach(item.data, (ite) => {
      //     this.areaBasicValue.xAxis.push(ite[0])
      //     this.areaBasicValue.series.push(ite[1])
      //   })
      // } else {
      //   const id = [1, 2, 3, 4, 5]
      //   _.forEach(id, (item) => {
      //     const params = {
      //       companyId: item,
      //       dateType: 'YEAR',
      //       startTime: '2010',
      //       endTime: '2019'
      //     }
      //     brandVolume(params)
      //       .then((data) => {
      //       })
      //   })
      // companyStatistics()
      //   .then((data) => { //已处理
      //     this.rankingFirmValue.arr = []
      //     _.forEach(data.data.series, (item) => {
      //       const rank = {
      //         name: item.title,
      //         data: item.data
      //       }
      //       this.rankingFirmValue.arr.push(rank)
      //     })
      //     _.forEach(this.rankingFirmValue.arr[0].data, (ite) => {
      //       this.areaBasicValue.xAxis.push(ite[0])
      //       this.areaBasicValue.series.push(ite[1])
      //     })
      //     this.areaBasicValue.name = data.data.unit
      //     this.rankingFirmValue.active = this.rankingFirmValue.arr[0].name
      //   })
      // }
    },
    requestBarTickAlign (item = null) {
      if (item) {
        this.barTickAlignValue.xAxis = []
        this.barTickAlignValue.series = []
        _.forEach(item.data, (ite) => {
          this.barTickAlignValue.xAxis.push(ite[0])
          this.barTickAlignValue.series.push(ite[1])
        })
      } else {
        countryStatistics()
          .then((data) => {
            this.rankingValue.arr = []
            _.forEach(data.data.series, (item) => {
              const rank = {
                name: item.title,
                data: item.data
              }
              this.rankingValue.arr.push(rank)
            })
            this.barTickAlignValue.xAxis = []
            this.barTickAlignValue.series = []
            _.forEach(this.rankingValue.arr[0].data, (ite) => {
              this.barTickAlignValue.xAxis.push(ite[0])
              this.barTickAlignValue.series.push(ite[1])
            })
            this.barTickAlignValue.name = data.data.unit
            this.rankingValue.active = this.rankingValue.arr[0].name
          })
      }
    },
    // banner图
    requestBanner () {
      this.$pdAxios({
        url: '/ensearch/banner',
        method: 'post',
        baseURL: baseUrl
      })
        .then((data) => {
          if (data.data.errCode === 200) {
            this.bannerValue.list = _.map(data.data.data, (item) => {
              item.imgUrl = item.img
              return item
            })
          }
        })
    },
    saveConsult (value) {
      var reg = 11 && /^1[3578]\d{9}$|^147\d{8}$/
      var regEmail = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (value.advisorytitle === '') {
        $('.wrap').text('Title cannot be empty！')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (value.advisorycontent === '') {
        $('.wrap').text('Content cannot be empty！')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (value.advisorycontent.length > 400) {
        $('.wrap').text('Content length cannot exceed 400')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (value.advisoryname === '') {
        $('.wrap').text('Name cannot be empty！')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (value.advisoryphone === '') {
        $('.wrap').text('Mobile number cannot be empty！')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (!reg.test(value.advisoryphone)) {
        $('.wrap').text('Incorrect format of mobile number！')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (value.advisoryemail === '') {
        $('.wrap').text('Mailbox cannot be empty！')
        $('.wrap').show().delay(1500).hide(100)
        return
      } else if (!regEmail.test(value.advisoryemail)) {
        $('.wrap').text('Incorrect mailbox format！')
        $('.wrap').show().delay(1500).hide(100)
        return
      }
      const data = {
        spaceid: value.refsid,
        title: value.advisorytitle,
        content: value.advisorycontent,
        company: value.advisorycompany,
        name: value.advisoryname,
        phone: value.advisoryphone,
        email: value.advisoryemail,
        address: value.advisoryaddress,
        captcha: value.advisorycapat
      }
      // pcConsult()
      this.$pdAxios({
        url: '/api/pc/consult',
        method: 'post',
        data: data
      }).then((data) => {
        if (data.data.state) {
          $('.wrap').text('Successful consultation！')
          $('.wrap').show().delay(1500).hide(100)
          $('#myModal').modal('hide')
        } else {
          $('.wrap').text(data.data.error)
          $('.wrap').show().delay(1500).hide(100)
        }
      })
    },
    selectTab () { // 筛选弹窗
      this.selectVisible = !this.selectVisible
      // this.selectValue =
    },
    // openBot () { // 打开机器人
    //   this.botShow = true
    //   this.botUrl = config.botUrlPrefix + '15967885091466566'
    //   // window.open(config.botUrlPrefix + '15909832704286430')
    // },
    gotoCountry () { // 跳转到国家专题
      this.$router.push({name: this.graphRouterName, params: {'country': this.extraData.name}})
    },
    changeRouter (tab, val, vals) { // 切换跳转专题路径
      this.$refs.graph.loading = true
      this.graphRouterName = this.grphClassifyValue[vals].value
      if (~~vals !== 1) { // 非地图
        this.isMap = false
        this.apiSearchNode = this.grphClassifyValue[vals].apiSearchNode
        this.apiSearchId = this.grphClassifyValue[vals].apiSearchId
        this.extraData = this.grphClassifyValue[vals].extraData
        this.graphValue.layout = this.grphClassifyValue[vals].layout
        // 切换图谱展示
        this.requestGraph()
      } else {
        this.isMap = true
      }
    },
    changePeopleClassify (tab, val, vals) { // 切换专题人物分类
      this.typeid = this.peopleStateValue[vals].value
      this.requestCharacterColumn()
    },
    changeColumn (type, value) { // 专栏点击事件
      if (type === 'gotoAsk') {
        this.consultVisible = true
        this.consultValue.refsname = value.space.name
        this.consultValue.refsid = value.space.spaceid
      } else if (type === 'gotoFocus') {
        if (value && value.space && value.space.collect) {
          this.$pdAxios({
            url: '/api/pc/delspacecollect',
            method: 'post',
            data: { // 取消订阅
              spaceid: value.space.spaceid,
              typeid: value.space.attention
            }
          }).then(function (data) {
            if (data.data.state) {
              $('.wrap').text('Cancel collection succeeded')
              $('.wrap').show().delay(1500).hide(100)
              if (value && value.space) {
                value.space.collect = !value.space.collect
              }
            } else {
              $('.wrap').text(data.data.error)
              $('.wrap').show().delay(1500).hide(100)
            }
          })
        } else {
          // spaceCollect()
          this.$pdAxios({
            url: '/api/pc/spacecollect', // 添加订阅
            method: 'post',
            data: { // 取消订阅
              spaceid: value.space.spaceid,
              typeid: value.space.attention
            }
          }).then(function (data) {
            if (data.data.state) {
              $('.wrap').text('Collection success')
              $('.wrap').show().delay(1500).hide(100)
              if (value && value.space) {
                value.space.collect = !value.space.collect
              }
            } else {
              $('.wrap').text(data.data.error)
              $('.wrap').show().delay(1500).hide(100)
            }
          })
        }
      } else if (type === 'gotoPeople') {
        this.$router.push({
          name: 'consultdetails',
          params: {
            name: value.space.alias,
            contentid: 0
          }
        })
      } else if (type === 'gotoArticle') {
        this.$router.push({
          name: 'consultorganization',
          params: {
            contentid: value.id
          }
        })
      }
    },
    changeSelectType (tab, val, vals) {
      this.selectVisible = false
      this.selectType = this.classifyTabsValue[vals].value
      this.filters = []
      this.$refs.selectPopcomfirm.clearMessage()
      this.requestSelectList()
    },
    changeUrl (val) { // 筛选列表 点击标题跳转
      let id = _.split(val.sourceAsMap.contentid, '_')[1]
      const kgId = encodeURIComponent(val.sourceAsMap.title) || ''
      const typeItem = _.find(searchMap.typeAgg, ['value', val.sourceAsMap.column])
      let type = (typeItem && typeItem.id) || val.type
      let path = this.$route.path + '/searchType/All/1//searchDetail/' + id + '/' + type + '/' + kgId
      if (!val.sourceAsMap.contentid) { // 研报
        id = val.sourceAsMap.eid
        type = '研报'
        path = this.$route.path + '/searchType/All/1//searchDetail/' + id + '/' + type + '/' + kgId + '/' +
          val.sourceAsMap.type
      }
      let query = ''
      if (val.sourceAsMap) {
        // 配置kw传参
        if (val.sourceAsMap['tags']) {
          query = `${query}kw=${val.sourceAsMap['tags'].toString()}`
        }
        if (val.sourceAsMap['one_level_state']) {
          query = `${query}&country=${val.sourceAsMap['one_level_state'].toString()}`
        }
      }
      path = path + '?' + query
      this.$router.push({path})
    },
    subContentId (contentid) {
      // 查找 站点是否存在
      var start = contentid.indexOf('_')

      if (start > 0) {
        var arr = contentid.split('_')
        return arr[1]
      } else {
        return contentid
      }

    },
    jumpList (val) { // 筛选列表分页器翻页
    },
    bannerInto (val) { // banner跳转
      if (val.url.indexOf('en.imsilkroad.com/db/') !== -1) {
        window.location.href = val.url
      } else {
        window.open(val.url)
      }
    },
    gotoService (val) { // 进入服务
      if (val.url.indexOf('en.imsilkroad.com/db/') !== -1) {
        window.location.href = val.url
      } else {
        window.open(val.url)
      }
    },
    requestGraph (id) {
      this.searchNode(id)
        .then((data) => {
          this.graphValue.graph = data
          this.handleUpdataLayout()
          // setTimeout(() => {
          //   if (this.$refs.graph.graph && this.$refs.grah.graph.netChart) {
          //     this.$refs.graph.handleUpdataLayout()
          //   } else {
          //     setTimeout(() => {
          //       this.$refs.graph.handleUpdataLayout()
          //     }, 2000)
          //   }
          // }, 1000)
          return Promise.resolve()
        })
    },
    handleUpdataLayout (num = 0) {
      if (num > 10) {
        return
      }
      // setTimeout(() => {
      //   if (this.$refs.graph.graph && this.$refs.grah.graph.netChart) {
      //     this.$refs.graph.handleUpdataLayout()
      //   } else {
      //     setTimeout(() => {
      //       num = num + 1
      //       this.handleUpdataLayout(num)
      //     }, 2000)
      //   }
      // }, 1000)
    },
    selectItem (val) {
      this.filters = val
      this.requestSelectList(false)
      this.$refs.selectionList.scrollTop()
    },
    requestSelectList: function (firstRequest = true, page = 1) {
      this.selectListValue.page = page
      this.selectListValue.load = true
      this.selectListValue.spaceLoadShow = true
      let allType = _.cloneDeep(searchMap.allSearchType)
      let aggs = _.cloneDeep(searchMap.searchAggs)
      const arr = searchMap.searchList[this.selectType === 'all' ? 'All' : this.selectType]
      aggs = _.filter(aggs, (item) => {
        item.k && item.k.name.indexOf('行业') !== -1 && (item.k.counts = 1000)
        item.k && item.k.name.indexOf('中国省份') !== -1 && (item.k.counts = 1000)
        item.k && item.k.name.indexOf('中国省份') !== -1 && (item.k.counts = 1000)
        return _.indexOf(arr, item.k.name) !== -1 && (item.k.name === '行业' || item.k.name === '中国省份')
      })
      if (this.selectType !== 'all') {
        let ite = _.find(searchMap.typeAgg, ['key', this.selectType])
        allType = [ite.id]
      }
      let filters = _.cloneDeep(this.filters)
      let height = []
      if (filters && filters.length) {
        filters = filters.filter((item) => {
          if (item.d === '0') {
            const o = {
              midd: 0,
              type: 1,
              value: item.v[0],
              column: `[${item.k}]`
            }
            height.push(o)
          }
          return item.d !== '0'
        })
      }
      allType = ['All']
      let data = {
        docTypeList: allType,
        kw: '',
        featureWeights: [],
        filters,
        hieghtQueryBean: height,
        isExplain: false,
        pageNo: this.selectListValue.page,
        pageSize: this.selectListValue.size,
        templateId: '',
        current: 0,
        sorts: '1', // 1降序 0升序
        isAggs: 1,
        sortField: 'published',
        aggs: aggs,
        token: this.searchToken,
        psn: 10005
      }
      if (!firstRequest) {
        data.isFilter = 1
      }
      this.$pdAxios({
        method: 'post',
        url: '/search/simplekw',
        baseURL: baseUrl,
        data: data
      }).then(
        (data) => {
          if (data.data.errCode === 200) {
            this.searchToken = data.data.data.token
            this.selectListValue.total = data.data.data.rsCount
            if (this.selectListValue.page > 1) {
              this.selectListValue.content = _.concat(this.selectListValue.content, data.data.data.rsData)
            } else {
              this.selectListValue.content = data.data.data.rsData
            }
            this.selectListValue.pageCount = _.ceil(this.selectListValue.total / this.selectListValue.size)
            if (firstRequest) {
              let selectValue = data.data.data.tAggregationItem || []
              const columnMessage = this.createCatName(this.selectType)
              columnMessage.isExist && selectValue.unshift(columnMessage.column)
              selectValue.push(this.createTimeFilter())
              for (let item of selectValue) {
                if (item && item.k.name) {
                  item.k._name = searchMap.chinaToEnglish[item.k.name] || ''
                }
              }
              this.selectValue = selectValue
            }
          } else if (data.data.message === 'token不合法') {
            this.selectListValue.page = this.selectListValue.page - 1
          } else {
            this.selectListValue.total = 0
            this.selectListValue.content = []
            this.selectListValue.pageCount = 0
          }
          this.selectListValue.spaceLoadShow = false
          setTimeout(() => {
            this.selectListValue.load = false
          }, 100)
        }
      ).catch(() => {
        this.selectListValue.total = 0
        this.selectListValue.content = []
        this.selectListValue.pageCount = 0
        this.selectListValue.spaceLoadShow = false
        setTimeout(() => {
          this.selectListValue.load = false
        }, 100)
      })
    },
    // 创建二级栏目
    createCatName (type) {
      const obj = {
        d: '0',
        k: {
          columnItem: 'catName.keyword',
          name: '二级栏目',
          type: 'terms'
        },
        v: []
      }
      let columnItem = []
      if (type === 'all') {
        Object.getOwnPropertyNames(this.column).forEach((key) => {
          Array.isArray(this.column[key]) && columnItem.push(...this.column[key])
        })
      } else {
        columnItem = this.column[type]
      }
      // let arr = columnItem && columnItem.map((item) => {
      //   return {
      //     key: item,
      //     value: item
      //   }
      // })
      obj.v = columnItem
      return {
        isExist: columnItem && columnItem.length,
        column: obj
      }
    },
    selectChaneRanking (event, type) {
      let itemData = ''
      if (type === 'BarTickAlign') {
        itemData = 'rankingValue'
      } else {
        itemData = 'rankingFirmValue'
      }
      let item = _.find(this[itemData].arr, ['name', event])
      item && this['request' + type](item)
    },
    // 创建时间筛选
    createTimeFilter () {
      const date = new Date()
      const nowTime = [date.getFullYear(), date.getMonth() + 1, date.getDate()]
      const time = {
        'last month': [...nowTime],
        'last three months': [...nowTime],
        'last half year': [...nowTime],
        'last year': [...nowTime],
        'now': nowTime
      }
      const changeTime = (item) => {
        let {key, index, num} = item
        if (time[key][index] > num) {
          time[key].splice(index, 1, time[key][index] - num)
        } else {
          time[key].splice(index, 1, 12)
          time[key].splice(index - 1, 1, time[key][index - 1] - 1)
        }
      }
      const changeArr = [
        {
          key: 'last month',
          index: 1,
          num: 1
        }, {
          key: 'last three months',
          index: 1,
          num: 3
        }, {
          key: 'last half year',
          index: 1,
          num: 6
        }, {
          key: 'last year',
          index: 0,
          num: 1
        }]
      // 创建时间
      changeArr.map(changeTime)
      // 处理时间位数
      Object.getOwnPropertyNames(time).forEach((item) => {
        time[item].forEach((_item, index) => {
          if (index === 1 || index === 2) {
            if (_item <= 9) {
              time[item].splice(index, 1, '0' + _item)
            }
          }
        })
        time[item] = time[item].join('-')
      })
      const obj = {
        d: '1',
        k: {
          columnItem: 'published',
          name: '时间',
          type: 'terms'
        },
        v: []
      }
      Object.getOwnPropertyNames(time).forEach((item) => {
        if (item !== 'now') {
          let value = {
            key: [time[item], time['now']],
            value: item
          }
          obj.v.push(value)
        }
      })
      return obj
    },
    requestCharacterColumn (page = 1) { // 记者专栏信息
      this.characterColumnValue.page = page
      this.characterColumnValue.spaceLoadShow = true
      const data = {
        typeid: this.typeid,
        sid: '',
        page: page
      }
      spaceList(data)
        .then((data) => {
          if (data.state === true) {
            if (this.characterColumnValue.page > 1) {
              this.characterColumnValue.content = _.concat(this.characterColumnValue.content, data.data)
            } else {
              this.characterColumnValue.content = data.data
            }
            this.characterColumnValue.pageCount = data.maxpage
          }
          this.characterColumnValue.spaceLoadShow = false
        }).catch(() => {
        this.characterColumnValue.spaceLoadShow = false
      })
    },
    clickNode (event) {
      if (this.selectVisible) {
        const dom = $('.select-dialog-wrap')[0]
        const button = $('.select-button')[0]
        const path = event.path
        if (path) {
          const isButton = _.findIndex(path, (item) => {
            return item === button
          })
          const isSame = _.findIndex(path, (item) => {
            return item === dom
          })
          if (isButton === -1) {
            isSame === -1 && (this.selectVisible = false)
          }
        }
      }
    },
    getVideoList() {
      this.$axios({
        url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/Video/0',
        method: 'get'
      }).then(data => {
        if(data && data.data) {
          const results = data.data.results || []
          this.seriviceValue = results.map(r => {
            const date = new Date(r.published)
            return {
              imgUrl: r.thumb,
              title: r.title,
              time: date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate(),
              url: 'https://en.imsilkroad.com/db/#/video/1/article/' + r.id
            }
          }).slice(0, 6)
        }
      }, function(response) {
        console.info(response);
        if(response) {
          console.log("失败");
        }
      })
    },
  }
}
</script>

<style scoped lang="less">

    @media screen and (min-width: 767px) {
        .patch-home {
            /*max-width: 1740px;*/
            /*min-height: 870px;*/
            /*height: ;*/
            height: calc(100vh - 69px) !important;
            margin: 0 auto;
        }
    }

    @media screen and (min-width: 767px) and (max-width: 1300px) {
        .ranking, .ranking-base {
            display: none !important;
        }

        .area-base, .bar-tick-align {
            width: 100% !important;
        }

        .ranking-select {
            display: block !important;
        }

        .middle-hidden {
            display: none;
        }
    }

    @media screen and (max-width: 766px) {

        .right {
            display: none !important;
        }

        .left {

            .graph-wrap {
                margin-bottom: 10px;
                height: 300px;
            }


            .country-state-chart {
                height: 200px !important;
            }
        }

        .middle {
            height: 100vh !important;
            margin-top: 10px;

            .middle {
                height: 23% !important;
            }
        }
    }

    @media screen and (max-width: 991px) and (max-width: 767px) {
        .service-entrance {
            height: calc(100% - 418px) !important;
        }
    }

    @media only screen and (max-width: 766px) {
        .left {
            height: auto !important;
        }

        .firm-chart {
            margin-top: 10px !important;
        }

        .filter-content {
            margin-top: 10px !important;
        }

        .head-list {
            min-height: 66px;
        }

        /deep/ .number-desc {
            line-height: 1;
        }

        .hidden-sm {
            display: none !important;
        }

        .service-entrance {
            height: auto !important;
        }

        .row {
            margin: 0 !important;
            padding: 10px 0;
        }

        .patch-home {
            height: calc(100vh - 71px - 60px) !important;
            padding: 0 !important;
            overflow: auto;
        }
    }

    .patch-home {
        width: 100%;
        height: 100%;
        box-sizing: border-box;
        padding: 18px 0 0 0;
    }

    /deep/ .el-tabs__item {
        font-weight: bolder !important;
        font-size: 16px !important;
    }

    .bot-wrap {
        position: fixed;
        top: 50%;
        right: 16px;
        z-index: 999;
    }

    .head-list {
        width: 100%;
        /*height: 124px;*/
        height: 12%;
        /*background: #ffffff;*/
    }

    .ranking {
        width: 20%;
        height: calc(100% - 15px);
    }

    .ranking-base {
        width: 25%;
        height: calc(100% - 15px);
    }

    .area-base {
        width: 75%;
        /*margin-top: -20px;*/
        height: 100%;
    }

    .bar-tick-align {
        width: 80%;
        /*margin-top: -20px;*/
        height: 100%;
    }

    .pd-tabs {
        width: 488px;
        height: 42px;
    }

    .patch-home-content {
        /*padding: 12px 0;*/
        margin-top: 12px;
        width: 100%;
        height: calc(88% - 20px);

        .left {
            height: 100%;
        }

        .country-state-chart {
            height: 31%;
        }

        .right {
            height: 100%;
        }

        .middle {
            height: 100%;
        }
    }

    .banner-wrap {
        height: 31%;
    }

    .country-state-chart {
        position: relative;
        width: 100%;
        /*height: 31%;*/
        /*min-height: 250px;*/
        background: #ffffff;
        padding: 0 5px 0 24px;
    }

    .service-entrance {
        width: 100%;
        height: calc(38% - 30px);
        background: #fff;
        /*min-height: 200px;*/
    }

    .classify-tabs {
        /*padding: 0 10px;*/
    }

    .rank-chart {
        display: flex;
        height: calc(100% - 54px);
        position: relative;

        img {
            height: 100%;
            width: 100%;
        }

        .overseas-enthusiasm {
            height: 100%;
            width: 100%;

            /deep/ .echarts_show {
                height: 100%;
                width: 100%;
                margin: 0 !important;

                > .brand_rank {
                    display: none !important;
                }

                .brand_media {
                    height: 100%;

                    > .title {
                        display: none !important;
                    }

                    .date_select {
                        width: 100%;
                        padding: 0;
                        overflow: hidden;

                        li {
                            &:nth-child(2), &:nth-child(5) {
                                display: none !important;
                            }

                            width: 33%;
                            height: 26px;
                            line-height: 26px;
                        }
                    }

                    .echarts_container {
                        height: calc(100% - 35px);
                        margin-top: 5px;

                        > div {
                            height: 100%;
                        }
                    }

                }

            }

            /deep/ .floor {
                display: none !important;
            }
        }

        .ps {
            position: absolute;
            right: 0;
            bottom: 0;
            padding: 0 5px;
            font-size: 12px;
            background: rgba(255, 255, 255, 1);
            z-index: 2;
        }
    }

    .firm-chart {
        margin-top: 18px;
    }

    .filter-content {
        padding: 0 24px 12px 24px;
        /*height: 534px;*/
        /*height: 53%;*/
        height: calc(69% - 20px);
        background: #ffffff;
        position: relative;
        margin-top: 18px;

        .filter-head-tab {
            display: flex;
            position: relative;
            width: 100%;
            align-items: center;
            margin-bottom: 18px;

            .classify-tabs-wrap {
                width: calc(100% - 61px);

                /deep/ .el-tabs__header {
                    margin: 0;
                }
            }

            .select-button {
                position: absolute;
                right: 0px;
                background: #409EFF;
                border-color: #66b1ff;
                color: #ffffff;
                /*width: 56px;*/
                /*margin-left: 5px;*/
                /*color: #ccc4cf;*/
                /*font-size: 15px;*/

                &:hover {
                    background-color: #66b1ff !important;
                }

                /*margin-bottom: 10px;*/
            }
        }

        .select-list-wrap {
            height: calc(100% - 73px);

            /deep/ .item-head-left {

                /deep/ .text-span {
                    border-color: #409EFF !important;
                    color: #409EFF !important;
                }
            }
        }

        .select-dialog-wrap {
            width: calc(100% - 48px);
            height: auto !important;
            /*height: 200px;*/
            position: absolute;
            z-index: 999;
            background: #ffffff;
            top: 54px;
            left: 24px;
        }
    }

    .graph-wrap {
        position: relative;
        width: 100%;
        background: #ffffff;
        /*height: 280px;*/
        height: 31%;
        padding: 0 24px 0 24px;

        .triangle {
            top: 18px;
        }

        /deep/ #classify-tab {
            width: 100%;

            .el-tabs__header {
                margin-bottom: 7px !important;

                .el-tabs__nav {
                    width: 100%;

                    .el-tabs__item {
                        width: calc(100% - 50px);
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: initial;
                    }
                }
            }
        }

        /deep/ .choose {
            position: absolute;
            right: 0px;
            top: 23px;
            width: 117px;
            transform: translateY(-50%);
            z-index: 9999;

            .el-input__suffix {
                display: none;
                font-size: 8px !important;
            }

            .el-input__inner {
                border: none;
                /*width: 89px;*/
                text-align: right;
                background: transparent !important;
            }
        }

        .normal-graph {
            height: calc(100% - 60px);
            cursor: pointer;
            background: #ffffff;
            object-fit: scale-down;
        }

        .normal-img {
            width: 100%;
        }
    }

    .people-column {
        background: #ffffff;
        /*height: 533px;*/
        height: calc(69% - 20px);
        box-sizing: border-box;
        padding: 0 24px 24px 24px;
        margin-top: 18px;

        .people-column-content {
            height: calc(100% - 64px);
        }
    }

    .bot-dialog {
        width: 100%;
        overflow: hidden;

        /deep/ .el-dialog {
            margin-left: calc(100% - 900px);

            .el-dialog__body {
                iframe {
                    padding: 0 20px 20px 20px;
                }
            }
        }

        /deep/ .el-dialog__header {
            /*padding: 0;*/

            .el-dialog__headerbtn {
                top: 12px;
            }
        }

        /deep/ .el-dialog__body {
            height: 700px;
            margin-top: -5px;
            padding: 0;

            iframe {
                border: none;
                width: 100%;
                height: 100%;

                /deep/ .whole {
                    height: 100% !important;
                }
            }
        }
    }

    /deep/ .pdvis-node-legend {
        display: none;
    }

    /deep/ #classify-tab {
        .el-tabs__item {
            line-height: 46px;
            height: 46px;
        }
    }

    .classify-tabs {
        height: 54px;
    }

    .triangle {
        position: absolute;
        z-index: 1000;
        top: 24px;
        right: 13px;
        width: 0;
        height: 0;
        border-right: 6px solid transparent;
        border-left: 6px solid transparent;
        border-top: 12px solid #ccc4cf;
        cursor: pointer;
    }

    .triangle-mid {
        position: absolute;
        right: 0;
        width: 0;
        height: 0;
        border-right: 10px solid transparent;
        border-left: 10px solid transparent;
        border-top: 13px solid #ccc4cf;
        cursor: pointer;
    }

    /deep/ .el-tabs__nav .el-tabs__active-bar {
        display: none;
    }

    /deep/ .el-button:active {
        border-color: #ffffff !important;
    }

    /deep/ .line .text-dark.active {
        border-bottom: 0 !important;
        padding-bottom: 0 !important;
    }

    /deep/ .people-column {
        .item-head {
            .item-head-left {
                overflow: hidden;

                .head-name {
                    padding-left: 4% !important;

                    div:nth-child(2) span {
                        height: 22px !important;
                    }

                    .tags {
                        padding-top: 4px !important;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            div:nth-child(2) {
                flex: 0 1;

                span {
                    display: inline-block;
                    white-space: nowrap;
                    height: 19px;
                }

                /*flex-shrink: 0 !important;*/
            }
        }
    }

    /deep/ .plantdata-ns .pd-panel-float-top .pd-panel-float-item {
        display: none;
    }

    .ranking-select {
        display: none;
        width: 35%;
        position: absolute;
        top: 23px;
        right: 11px;
        transform: translateY(-50%);
    }

    .more-btn {
        position: absolute;
        top: 12px;
        right: 11px;
        z-index: 1;
        color: #0078FF !important;
        border-left: 0;
        background: transparent;
    }

    button {
        &:focus, &:active:focus,
        &.active:focus,
        &.focus,
        &:active.focus,
        &.active.focus {
            outline: none !important;
            box-shadow: none !important;
        }
    }

    /deep/ .cursor {
        cursor: pointer;
    }

    /deep/ #classify-tab .el-tabs__item {
        font-size: 13px !important;
    }

    /deep/ .el-input__icon {
        font-size: 6px !important;
    }

    .char-title-conent {
        width: 100%;
        /*display: flex;*/
        /*align-items: center;*/
        /*justify-content: space-between;*/
        position: relative;

        .database {
            position: absolute;
            top: 50%;
            right: 0;
            transform: translate(0, -50%);
            /*margin: 0 0 0 6px;*/
            white-space: nowrap;
            color: #0078FF;
            font-size: 14px;
        }
    }

    /deep/ button {
        &:focus {
            outline: none !important;
        }
    }

    /deep/ .nano > .nano-content:focus {
        outline: none !important;
    }

    /deep/ .pd-panel .pdvis-zoom-slider-container {
        display: none;
    }
</style>
